import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "ScrollBottom"
})
export default class ScrollBottom extends Vue {
  @Prop() private element?: string;

  bottomOfWindow = false;
  documentElement =
    document.getElementById(this.element ?? "") ?? document.documentElement;
  childElement = document.getElementById(this.element ?? "");

  scroll() {
    (this.childElement ?? window).onscroll = () => {
      this.bottomOfWindow =
        this.documentElement.scrollTop +
          (this.childElement
            ? this.childElement.clientHeight
            : window.innerHeight) +
          10 >=
        (this.childElement
          ? this.childElement.scrollHeight
          : this.documentElement.offsetHeight);

      if (this.bottomOfWindow) {
        this.$emit("onFinalScroll");
      }
    };
  }
  mounted() {
    this.scroll();
  }
}
